<template>
	<div>
		<ASpin :spinning="spinning" :tip="tip"></ASpin>
	</div>
</template>
<script>
	import Stomp from "stompjs"
	import { mapActions, mapGetters } from 'vuex'
	export default {
		data() {
			return {
				spinning: false,
				tip: '',
				config: {
					login: 'app',
					passcode: '1',
				},
				client: null
			}
		},
		created() {
			this.connect()
		},
		methods: {
			...mapActions(['refreshTerminalAbnormal', 'refreshProductionTable', 'refreshReceiveTable', 'resetWorkOrderId','setRemind'
			]),
			//开启连接
			connect() {
				if (!(localStorage.getItem("enableMqtt") == 'true')) return
				this.openSpinning("开始连接MQTT...")
				//连接地址 存在配置地址直接使用 不存在配置地址使用代理
				let host = this.$config.serverIp ? `ws://${this.$config.serverIp}:${this.$config.pushPort}/ws` :
					`ws:${location.host}/stomp`
				this.client = Stomp.client(host)
				this.client.connect({
					...this.config,
					'client-id': localStorage.getItem('mac')
				}, this.onSuccess, this.onFailed)
			},
			//连接成功
			onSuccess() {
				this.$message.success(`MQTT连接成功`)
				console.log(`MQTT连接成功`)
				this.spinning = false
				this.client.subscribe(`/topic/${localStorage.getItem('mac')}`, this.callback)
				this.client.subscribe(`/topic/start_work_order_status`, this.callback)
			},
			//连接失败
			onFailed(frame) {
				console.error(`MQTT连接失败`, frame)
				this.spinning = false
				setTimeout(() => {
					this.connect()
				}, 3000)
			},
			//开启遮罩提示
			openSpinning(tip) {
				this.tip = tip
				this.spinning = true
			},
			//mqtt消息回调
			callback(frame) {
				//console.log(`收到mqtt消息`, frame)
				let message = frame.body
				if (!message) return
				let messageObj = JSON.parse(message)
				console.log('messageObj：', messageObj)
				let messageType = messageObj.messageType
				if (!messageType) return
				switch (messageType) {
					//刷新终端信息
					case "TERMINAL_REFRESH":
						alert("终端信息修改，刷新页面")
						location.reload()
						break
						//刷新异常信息
					case "ABNORMAL_REFRESH":
						this.refreshTerminalAbnormal()
						break
						//刷新工单列表
					case "ORDER_LIST_REFRESH_IN_APP":
						this.resetWorkOrderId(messageObj.data)
						break
						//刷新工单列表
					case "MARQUEE":
						//console.log('MARQUEE')
						this.setRemind('open')
						break
				}
			}
		},
		components: {
			...mapGetters(['getWorkOrderId'])
		},
	}
</script>
<style lang="less">
</style>
